import { create } from 'zustand'

export const useSyncStore = create((set, get) => ({
  activeSyncs: {
    META_ADS: false,
    GOOGLE_ADS: false,
    GOOGLE_ANALYTICS: false
  },
  syncStartTimes: {
    META_ADS: null,
    GOOGLE_ADS: null,
    GOOGLE_ANALYTICS: null
  },
  autoTimers: {
    META_ADS: null,
    GOOGLE_ADS: null,
    GOOGLE_ANALYTICS: null
  },
  
  startSync: (platform) => {
    const state = get();
    
    // Clear existing timer if any
    if (state.autoTimers[platform]) {
      clearTimeout(state.autoTimers[platform]);
    }
    
    // Set 5-minute auto-clear timer
    const timer = setTimeout(() => {
      get().endSync(platform);
    }, 5 * 60 * 1000); // 5 minutes
    
    set((state) => ({
      activeSyncs: { ...state.activeSyncs, [platform]: true },
      syncStartTimes: { ...state.syncStartTimes, [platform]: new Date() },
      autoTimers: { ...state.autoTimers, [platform]: timer }
    }));
  },
  
  endSync: (platform) => {
    const state = get();
    
    // Clear timer if exists
    if (state.autoTimers[platform]) {
      clearTimeout(state.autoTimers[platform]);
    }
    
    set((state) => ({
      activeSyncs: { ...state.activeSyncs, [platform]: false },
      syncStartTimes: { ...state.syncStartTimes, [platform]: null },
      autoTimers: { ...state.autoTimers, [platform]: null }
    }));
  },
  
  getSyncDuration: (platform) => {
    const state = get();
    if (!state.activeSyncs[platform] || !state.syncStartTimes[platform]) {
      return null;
    }
    return Math.floor((new Date() - state.syncStartTimes[platform]) / 1000);
  },
  
  endAllSyncs: () => {
    const state = get();
    
    // Clear all timers
    Object.values(state.autoTimers).forEach(timer => {
      if (timer) clearTimeout(timer);
    });
    
    set({
      activeSyncs: {
        META_ADS: false,
        GOOGLE_ADS: false,
        GOOGLE_ANALYTICS: false
      },
      syncStartTimes: {
        META_ADS: null,
        GOOGLE_ADS: null,
        GOOGLE_ANALYTICS: null
      },
      autoTimers: {
        META_ADS: null,
        GOOGLE_ADS: null,
        GOOGLE_ANALYTICS: null
      }
    });
  }
})); 